import React, { useState } from "react";
import {
  clearSuperAdminSession,
  getSuperAdminProfile,
} from "../../api/superadminClient";
import OverviewPanel from "./superadmin/OverviewPanel";
import TenantsPanel from "./superadmin/TenantsPanel";
import PricingPanel from "./superadmin/PricingPanel";
import EmailPanel from "./superadmin/EmailPanel";
import MessagingPanel from "./superadmin/MessagingPanel";
import AuditPanel from "./superadmin/AuditPanel";
import "./SuperAdminPages.css";

const TABS = [
  { key: "overview", label: "Overview" },
  { key: "tenants", label: "Tenants" },
  { key: "pricing", label: "Pricing" },
  { key: "email", label: "Email" },
  { key: "messaging", label: "Messaging" },
  { key: "audit", label: "Audit Trail" },
];

// Shell only. Each panel owns its own state and fetches on first open, so the
// dashboard no longer loads every dataset up front just to render one section.
export default function SuperAdminDashboardPage() {
  const [activeTab, setActiveTab] = useState("overview");
  const [error, setError] = useState("");
  const [tenantsReloadKey, setTenantsReloadKey] = useState(0);

  const profile = getSuperAdminProfile();

  const handleLogout = () => {
    clearSuperAdminSession();
    window.location.href = "/superadmin/login";
  };

  return (
    <div className="superadmin-shell">
      <header className="superadmin-header">
        <div>
          <h1>Superadmin Dashboard</h1>
          <p>
            Platform view only. This area is isolated from the tenant product
            UI.
          </p>
        </div>
        <div className="superadmin-header-actions">
          <span className="superadmin-profile">
            {profile?.firstName || "Super"} {profile?.lastName || "Admin"}
          </span>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </header>

      <nav className="superadmin-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`superadmin-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => {
              setError("");
              setActiveTab(tab.key);
            }}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {error ? <div className="superadmin-error">{error}</div> : null}

      {activeTab === "overview" && <OverviewPanel onError={setError} />}
      {activeTab === "tenants" && (
        <TenantsPanel onError={setError} reloadKey={tenantsReloadKey} />
      )}
      {activeTab === "pricing" && (
        <PricingPanel
          onError={setError}
          onTenantCreated={() => setTenantsReloadKey((k) => k + 1)}
        />
      )}
      {activeTab === "email" && <EmailPanel onError={setError} />}
      {activeTab === "messaging" && <MessagingPanel onError={setError} />}
      {activeTab === "audit" && <AuditPanel onError={setError} />}
    </div>
  );
}
